'use client';

import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from 'recharts';
import { financialChartData } from '@/lib/data/yayasan';

const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        return (
            <div className="bg-surface border border-border-main p-4 rounded-2xl shadow-xl">
                <p className="font-bold text-foreground mb-2 text-sm">{label} 2024</p>
                <div className="flex flex-col gap-1.5">
                    <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-primary"></div>
                        <span className="text-xs text-secondary font-medium">Pendapatan:</span>
                        <span className="text-xs font-bold text-foreground ml-auto">
                            {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(payload[0].value)}
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-border-main"></div>
                        <span className="text-xs text-secondary font-medium">Pengeluaran:</span>
                        <span className="text-xs font-bold text-foreground ml-auto">
                            {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(payload[1].value)}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default function FinancialChart() {
    return (
        <div className="bg-surface border border-border-main p-8 rounded-[2.5rem] shadow-sm flex flex-col">
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h3 className="text-lg font-bold text-foreground">Analisis Arus Dana</h3>
                    <p className="text-xs text-secondary font-medium mt-1">Konsolidasi tahunan seluruh sekolah</p>
                </div>
                <div className="flex gap-4">
                    <div className="flex items-center gap-2">
                        <div className="w-2.5 h-2.5 rounded-full bg-primary"></div>
                        <span className="text-[10px] font-bold text-secondary uppercase tracking-wider">Masuk</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-2.5 h-2.5 rounded-full bg-border-main"></div>
                        <span className="text-[10px] font-bold text-secondary uppercase tracking-wider">Keluar</span>
                    </div>
                </div>
            </div>

            <div className="w-full h-[350px]">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={financialChartData}
                        margin={{
                            top: 10,
                            right: 0,
                            left: 0,
                            bottom: 0,
                        }}
                        barGap={8}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2ECE6" opacity={0.5} />
                        <XAxis
                            dataKey="month"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: '#8da495', fontSize: 10, fontWeight: 600 }}
                            dy={10}
                        />
                        <Tooltip
                            content={<CustomTooltip />}
                            cursor={{ fill: 'var(--color-primary-soft)', opacity: 0.2, radius: 8 }}
                        />
                        <Bar
                            dataKey="income"
                            fill="var(--color-primary)"
                            radius={[6, 6, 6, 6]}
                            barSize={12}
                            animationDuration={1500}
                        />
                        <Bar
                            dataKey="expense"
                            fill="#cbd5e1"
                            radius={[6, 6, 6, 6]}
                            barSize={12}
                            animationDuration={1500}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
